import React, { useState } from 'react'
import { Modal } from 'antd'
import './BadgesSection.scss'
import { ImagePreview } from '../../../../components'
import badgeIcon from '../../../../assets/badge-icon.svg'
import { useTranslation } from 'react-i18next'

const BadgesSection = ({ leaderboardData }) => {
  const { badges = [] } = leaderboardData
  const [modalVisible, setModalVisible] = useState(false)

  const handleBadgeClick = () => {
    if (badges.length > 0) setModalVisible(true)
  }
  const handleModalClose = () => setModalVisible(false)

  const { t } = useTranslation()

  return (
    <div className="badges-section">
      <div className="badges-left">
        <h3 className="badges-title">{t('v2:badges')}</h3>
        {badges.length > 0 && (
          <div
            className="badges-section-grid"
            onClick={handleBadgeClick}
            style={{ cursor: 'pointer' }}
          >
            {badges.slice(0, 4).map(badge => (
              <div key={badge.id + '' + badge.path} className="badge">
                <img
                  src={badge.link}
                  className="badge-section-image"
                  alt="badge"
                />
              </div>
            ))}
            {badges.length > 4 && (
              <div className="badges-section-count">
                +{badges.length - 4} {t('v4:more')}
              </div>
            )}
          </div>
        )}
        {badges.length === 0 && (
          <div className="badges-section-empty">{t('v4:no_badge_yet')}</div>
        )}
      </div>

      <div className="badges-right">
        <div className="badges-icon">
          <img src={badgeIcon} alt="Badge icon" width="64" height="65" />
        </div>
      </div>

      <Modal
        title="All Badges"
        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={500}
        className="badge-modal"
        centered
      >
        <div className="badge-grid">
          {badges.map((badge, idx) => (
            <div key={badge.id + '-' + idx} className="badge-grid-item">
              <ImagePreview
                src={badge.link}
                alt="badge"
                className="badge-grid-image"
              />
            </div>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default BadgesSection
